import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// REPAYMENT APIS (FormData-based)
// Controller: Repaycon.php
// ================================

// 1) Get Repayment Stats
export async function getRepaymentStats(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}repaycon/get_repayment_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Get Repayments List
// POST: admin_id, page_no, keyword, statusFilter, bucketFilter, sortBy
export async function getRepayments(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("page_no", payload.page_no ?? 0);
    fd.append("keyword", payload.keyword || "");

    // filters
    fd.append("statusFilter", payload.statusFilter || ""); // DUE/PAID/OVERDUE
    fd.append("bucketFilter", payload.bucketFilter || ""); // TODAY/7D/30D
    fd.append("sortBy", payload.sortBy || "DATE_ASC"); // DATE_ASC/DATE_DESC/AMOUNT_ASC/AMOUNT_DESC

    const res = await axios.post(`${apiBaseUrl}repaycon/get_repayments`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Get Single EMI By ID
export async function getRepaymentById(emi_id) {
  try {
    const fd = new FormData();
    fd.append("emi_id", emi_id);

    const res = await axios.post(`${apiBaseUrl}repaycon/get_repayment_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 4) Mark EMI as Paid (Admin Manual Settlement)
// POST: emi_id, admin_id, txn_id, method, paid_at
export async function markEmiPaid(payload) {
  try {
    const fd = new FormData();
    fd.append("emi_id", payload.emi_id || "");
    fd.append("admin_id", payload.admin_id || "");
    fd.append("txn_id", payload.txn_id || "");
    fd.append("method", payload.method || "");
    fd.append("paid_at", payload.paid_at || "");

    const res = await axios.post(`${apiBaseUrl}repaycon/mark_paid`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 5) Export Repayments Excel
// POST: admin_id, keyword, statusFilter, bucketFilter, sortBy
export async function exportRepaymentsXl(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("keyword", payload.keyword || "");

    fd.append("statusFilter", payload.statusFilter || "");
    fd.append("bucketFilter", payload.bucketFilter || "");
    fd.append("sortBy", payload.sortBy || "DATE_ASC");

    const res = await axios.post(`${apiBaseUrl}repaycon/export_repayments_xl`, fd, {
      responseType: "blob",
    });

    return res;
  } catch (err) {
    return null;
  }
}

// 6) Send Reminder
// POST: admin_id, emi_id
export async function sendEmiReminder(payload) {
  try {
    const fd = new FormData();
    fd.append("admin_id", payload.admin_id || "");
    fd.append("emi_id", payload.emi_id || "");

    const res = await axios.post(`${apiBaseUrl}repaycon/send_reminder`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}
